export const ExpiredApplication = () => {
  return (
    <div className="flex flex-col gap-l px-l py-m">
      <h2 className="m-0 text-2xl font-bold">This paylink has now expired</h2>
      <p className="m-0 text-m font-reg text-structure-20">
        Your pay link's expired after 7 days of inactivity. It's easy to refresh
        it - just contact us and we'll sort it.
      </p>
    </div>
  );
};
